export const TEMPLATE_NAMES = {
  PDP: 'AccommodationPage',
}

export const BRAND = {
  SUNWEB: 'sunweb',
  ELIZA: 'eliza',
}

export const SUMMER_PATHS = [
  '/vakantie/',
  '/nl/vakantie/',
  '/fr/vacances/',
  '/solresor/',
  '/rejser/',
  '/vacances/',
] as const
